import apiFunctions from '..';
import { QueueActionParam } from '../../types/queueStatus';

const apiUrl = 'StatusCheck';

const statusApiFunctions = {
  getComponentStatusCheckList: async () => {
    return await apiFunctions.apiPost(apiUrl + '/GetComponentStatusCheckList');
  },
  checkComponentStatus: async (componentStatusCheckId: string) => {
    return await apiFunctions.apiPost(apiUrl + '/CheckComponentStatus', {
      componentStatusCheckId: componentStatusCheckId,
    });
  },
  getQueueStatuses: async () => {
    return await apiFunctions.apiPost(apiUrl + '/GetQueueStatusList');
  },
  performQueueAction: async (param: QueueActionParam) => {
    return await apiFunctions.apiPost(apiUrl + '/PerformQueueAction', param);
  },
};

export default statusApiFunctions;
